<app-admin-boilerplate>
    <h1>Create a New Event</h1>
    <core-accordion [value]="currentStep" [linear]="true" [formGroup]="eventFormOne">
        <core-accordion-panel header="Name Your Event">
            <div class="flex flex-col gap-2 w-96 mb-3">
                <input type="text" formControlName="eventName">
                <small>Remember: Your players will always be able to see the event system and host, you dont need to include it here</small>
            </div>
            <div class="flex gap-3">
                <div class="flex flex-col gap-2 w-40 mb-3">
                    <label for="eventSystem">Event System</label>
                    @defer (when permittedEventSystems$ | async){
                        @if (permittedEventSystems$ | async; as permittedEventSystems){
                            <select name="eventSystem" formControlName="systemID" (change)="updateEventHosts()">
                                @for(eventSystem of permittedEventSystems; track $index){
                                    <option [value]="eventSystem.systemID">{{ eventSystem.name }}</option>
                                }
                            </select>
                        }
                    }
                    @placeholder {
                        <p-skeleton height="2rem" class="mb-2" />
                    }
                </div>  
                <div class="flex flex-col gap-2 w-40 mb-3">
                    <label for="eventHost">Event Host</label>
                    @defer (when permittedEventHosts$ | async){
                        @if (permittedEventHosts$ | async; as permittedEventHosts) {
                            <select name="eventHost" formControlName="hostID">
                                @for(eventHost of permittedEventHosts; track $index){
                                    <option [value]="eventHost.hostID">{{ eventHost.name }}</option>
                                }
                            </select>
                        }
                    }
                    @placeholder {
                        <p-skeleton height="2rem" class="mb-2" />
                    }
                </div>  
                <div class="flex flex-col gap-2 w-40 mb-3">
                    <label for="organiser">Organiser</label>
                    @defer (when availableOrganisers$ | async){
                        @if (availableOrganisers$ | async; as availableOrganisers) {
                            <select name="organiser" formControlName="organiserID" [disabled]="availableOrganisers.length <= 1" (change)="organiserChanged()">
                                @for(organiser of availableOrganisers; track $index){
                                    <option [value]="organiser.organiserID">{{ organiser.name }}</option>
                                }
                            </select>
                        }
                    }
                    @placeholder {
                        <p-skeleton height="2rem" class="mb-2" />
                    }
                </div> 
            </div>
            @if (eventFormOne.controls['organiserID'].value && !(selectOrganiserVerified$ | async)){
                <div class="bg-amber-100 rounded-sm border-amber-500 w-1/2 p-4 my-3">
                    <p class="font-semibold mb-3">Your payment settings have not been configured!</p>
                    <div class="flex gap-3">
                        <fa-icon [icon]="['fas','warning']" size="xl" class="text-amber-700 mt-2"/>
                        <div class="text-sm">
                            You haven't set up a payment provider yet.<br/>
                            <a class="underline" [routerLink]="['/admin','organisers',eventFormOne.controls['organiserID'].value]">Configure your payment settings</a>
                        </div>
                    </div>
                    
                </div>
            }
            <div class="mb-3">
                <button class="primaryButton" [disabled]="!eventFormOne.valid" (click)="currentStep = 1">Next</button>
            </div>
        </core-accordion-panel>
        <core-accordion-panel header="When and Where" [formGroup]="eventFormTwo">
            <div class="flex gap-3">
                <div class="flex flex-col gap-2 w-40 mb-3">
                    <label for="startDate">Start Date</label>
                    <input type="date" name="startDate" formControlName="startDate">
                </div>
                <div class="flex flex-col gap-2 w-40 mb-3">
                    <label for="endDate">End Date</label>
                    <input type="date" name="endDate" formControlName="endDate" [min]="eventFormTwo.controls['startDate'].value" >
                </div>
            </div>
            <div class="mb-3">
                <small>For one day events the end date needs to be the same as the start</small>
            </div>
            <div class="flex flex-col gap-2 w-96 mb-3">
                <label for="location">Location</label>
                <input type="text" name="location" formControlName="location" >
                <small>We will link this out to Google Maps, ideally use an address or landmark recognised by Google Maps</small>
            </div>
            <div class="mb-3">
                <button class="primaryButton" [disabled]="!eventFormOne.valid || !eventFormTwo.valid" (click)="currentStep = 2">Next</button>
            </div>
        </core-accordion-panel>
        <core-accordion-panel header="Character Invitation" [formGroup]="eventFormThree">
            <div class="flex flex-col gap-2 w-full mb-3 h-64">
                <small>This is your in-character blurb as to why your players are attending. Is it a royal summons? A wanted poster? This is your chance to hook your players into your event</small>
                <p-editor formControlName="characterInvitation" class="h-40" />
            </div>
            <div class="mb-3">
                <button class="primaryButton" [disabled]="!eventFormOne.valid || !eventFormTwo.valid || !eventFormThree.valid" (click)="currentStep = 3">Next</button>
            </div>
        </core-accordion-panel>
        <core-accordion-panel header="Event Information" [formGroup]="eventFormFour">
            <div class="flex flex-col gap-2 w-full mb-3 h-72">
                <p><small>We've motivated your characters, now lets give your players the key details. This is the opportunity to share the out-of-character information they may need to for your event</small></p>
                <p><small>Examples include if your players need a tent, what the parking options are, nearest public transport options?</small></p>
                <p-editor formControlName="eventInformation" class="h-40"  />
            </div>
            <div class="mb-3">
                <button class="primaryButton" [disabled]="!eventFormOne.valid || !eventFormTwo.valid || !eventFormThree.valid || !eventFormFour.valid" (click)="currentStep = 4">Next</button>
            </div>
        </core-accordion-panel>
        <core-accordion-panel header="Promotional Hook" [formGroup]="eventFormFive">
            <div class="flex flex-col gap-2 w-full mb-3 h-40">
                <p><small>Now let's write a small promotional hook. This is the line that will be used on the front page, and any link previews.</small></p>
                <p-editor formControlName="promoDescription" class="h-20" [placeholder]="promoPlaceholders[0]"  />
            </div>
            <div class="mb-3">
                <button class="primaryButton" [disabled]="!eventFormOne.valid || !eventFormTwo.valid || !eventFormThree.valid || !eventFormFour.valid || !eventFormFive.valid || disableCreate" (click)="createEvent()">
                    @if (disableCreate){
                        <fa-icon [icon]="['fas','spinner']"  animation="spin"/> Creating...
                    }
                    @else { Create Your Event }
                </button>
            </div>
        </core-accordion-panel>
    </core-accordion>
</app-admin-boilerplate>

